import { Grid } from '@mui/material';
import * as React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';

import styles from './SearchResults.module.scss';
import { ViewEnum } from './ViewEnum';
import { OrderEnum } from './OrderEnum';

interface ISearchResltsHeaderProps {
    sortRelevance: boolean;
    sortDesc: boolean;
    currentResults: number;
    totalResults: number;
    callSearchApi: any;
    viewSelected: any;
}
interface ISearchResultsHeaderState {
    searchRelevance: boolean;
    searchDesc: boolean;
    searchType: number;
    viewDtails: boolean;
    maxResults: number;
    resultText: string;
}

export class SearchResultsHeader extends React.Component<ISearchResltsHeaderProps, ISearchResultsHeaderState> {
    constructor(props: ISearchResltsHeaderProps) {
        super(props);

        this.state = {
            searchRelevance: this.props.sortRelevance,
            searchDesc: this.props.sortDesc,
            searchType: this.props.sortRelevance ? 1 : this.props.sortDesc? 0 : 2,
            viewDtails: true,
            maxResults: this.props.currentResults + 10 >= this.props.totalResults ? this.props.totalResults : this.props.currentResults + 10,
            resultText: this.props.totalResults > 0 ? (this.props.currentResults + 1).toString() : '0',
        }
        // this.setState({
        //     searchType: this.getOrderTypeIndex()
        // })
    }

    componentDidMount() {
        this.setState({
            maxResults: this.props.currentResults + 10 >= this.props.totalResults ? this.props.totalResults : this.props.currentResults + 10,
            resultText: this.props.totalResults > 0 ? (this.props.currentResults + 1).toString() : '0'
        });
    }

    componentDidUpdate(prevProps: ISearchResltsHeaderProps) {
        if (this.props != prevProps) {
            this.setState({
                maxResults: this.props.currentResults + 10 >= this.props.totalResults ? this.props.totalResults : this.props.currentResults + 10,
                resultText: this.props.totalResults > 0 ? (this.props.currentResults + 1).toString() : '0'
            });
        }
    }

    render() {
        const viewOptions = [
            { key: ViewEnum.ViewDetails, value: ViewEnum.ViewDetails, text: (<div><Icon name='bars' />View</div>) },
            { key: ViewEnum.ViewFlat, value: ViewEnum.ViewFlat, text: (<div><Icon name='minus' />View</div>) },
        ]
        const orderOptions = [
            {key: OrderEnum.OrderNewest, value: OrderEnum.OrderNewest, text: (<div><Icon name='sort amount down' />Newest</div>)},
            {key: OrderEnum.OrderRelevance, value: OrderEnum.OrderRelevance, text: (<div><Icon name='star outline' />Relevance</div>)},
            {key: OrderEnum.OrderOldest, value: OrderEnum.OrderOldest, text: (<div><Icon name='sort amount up' />Oldest</div>)}
        ]

        return (
            <Grid container spacing={1} className={styles.searchResultsHeader}>
                <Grid item xs={5} className={styles.resultsLeft}>
                    <div className={styles.resultsCount}>Showing {this.state.resultText}-{this.state.maxResults} of {this.props.totalResults} results</div>
                    {/* <div className={styles.resultsRestriction}>0 results have access restriction</div> */}
                </Grid>
                <Grid item xs={1} className={styles.resultsMiddle}>
                    {/* <Icon name='ellipsis horizontal' className={styles.resultsMore} /> */}
                    <span className={styles.resultsSeparator}>|</span>
                </Grid>
                <Grid item xs={6} className={styles.resultsRight}>
                    <Dropdown placeholder='View' fluid selection className={styles.resultsdropDown} options={viewOptions} defaultValue={viewOptions[0].value} onChange={(e, d) => this.viewChange(e, d)} aria-label='Select View Option' />
                    <Dropdown placeholder="Order" fluid selection className={styles.orderdropDown} 
                    options={orderOptions} value={orderOptions[this.state.searchType].value} 
                    onChange={(e,d) => this.orderChange(e,d)} aria-label="Select Order Option"/>
                    {/* <button className={styles.resultsButton} onClick={this.searchOrderHandle.bind(this)}>
                        Contract date
                        {this.state.searchDesc ? <Icon name='arrow down' /> : <Icon name='arrow up' />}
                    </button> */}
                </Grid>
            </Grid>
        );
    }

    private searchOrderHandle() {
        this.props.callSearchApi(!this.state.searchDesc).then(() => {
            this.setState({
                searchDesc: !this.state.searchDesc
            });
        });
    }
    private getOrderTypeIndex(){
        if(this.state.searchRelevance)
            return 1;
        if (this.state.searchDesc)
            return 0;
        return 2;
    }

    private orderChange(e: any, data: any){
        switch(data.value){
            case OrderEnum.OrderNewest:
                this.props.callSearchApi(true, false).then(() => {
                    this.setState({
                        searchDesc: true,
                        searchRelevance: false,
                        searchType: 0
                    });
                });
                break;
            case OrderEnum.OrderOldest:
                this.props.callSearchApi(false, false).then(() => {
                    this.setState({
                        searchDesc: false,
                        searchRelevance: false,
                        searchType: 2
                    });
                });
                break;
            case OrderEnum.OrderRelevance:
                this.props.callSearchApi(true, true).then(() => {
                    this.setState({
                        searchDesc: true,
                        searchRelevance: true,
                        searchType: 1
                    });
                });
                break;
            default:
                break;
        }
    }

    private viewChange(e: any, data: any) {
        this.props.viewSelected(data.value);
    }

}